import React from "react";
import "./main.scss";


const Form = (props) => {
    return (
        <div className="component" >
            <div className="wordContainer">
                <a className = "subtitle" href="mailto:s9bakingdc@gmail.com">
                    Contact us at s9bakingdc@gmail.com with inquiries
                </a>
            </div>
        </div>
    )
}
export default Form;